<template>
  <div class="allocation-con">
    <StepsHeader :activeStep="activeStep"/>
    <div class="step-con">
      <Step1 v-if="activeStep===1"
             :orderData="sortedAllocationItemsById"
             :onNext="firstStepNextClick"/>
      <Step2 v-if="activeStep===2" :onNext="secondStepNextClick" :onBack="()=>goToStep(1)"
             :onCancel="stepCancelClick"/>
      <Step3 v-if="activeStep===3"
             :addresses="allocationData.addresses"
             :onNext="thirdStepNextClick"
             :onBack="()=>goToStep(2)"
             :onCancel="stepCancelClick"/>
      <Step4 v-if="activeStep===4"
             :onNext="fourthStepNextClick"
             :onBack="()=>goToStep(3)"
             :onCancel="stepCancelClick"/>
      <Step5 v-if="activeStep===5"
             :orderData="sortedAllocationItemsById"
             :onNext="fifthStepNextClick"
             :onBack="()=>goToStep(4)"
             :onCancel="stepCancelClick"/>
    </div>
    <LocalAllocationOrders v-if="localStorageData&&localStorageData.length>0"
                           :lineItems="allocationData.lineItems"
                           :localOrdersData="localStorageData"
                           :onFinishAllocated="finishAllocated"
                           :onDeleteItem="deleteLocalItem"
                           :onUpdateItem="updateLocalItem"
                           :errorArray="errorArray"
    />
    <AllocatedOrders :editable="true"
                     :ordersData="allocationData.allocations"
                     :onDeleteItem="deleteAllocatedItem"
                     :onUpdateItem="updateAllocatedItem"
    />
    <UpdateLocalItemPopup v-if="popupVisible"
                          :onSave="onSave"
                          :onCancel="onCancel"
                          isAdmin
                          :items="sortedAllocationItemsById"
                          :addresses="allocationData.addresses"
                          :currentAllocatedData="currentAllocatedData"/>
    <UpdateItemPopup v-if="popupVisible2"
                     :onSave="onSave2"
                     :onCancel="onCancel2"
                     :data="updateAllocationData"
                     :addresses="allocationData.addresses"
    />
  </div>
</template>

<script>
import StepsHeader from './StepsHeader.vue';
import Step1 from './Step1.vue';
import Step2 from './Step2.vue';
import Step3 from './Step3.vue';
import Step4 from './Step4.vue';
import Step5 from './Step5.vue';
import {VueGoodTable} from 'vue-good-table';
import {sendOrder, deleteOrder, updateOrder} from '../actions/Allocation';
import AllocatedOrders from "./AllocatedOrders.vue";
import LocalAllocationOrders from "./LocalAllocationOrders.vue";
import UpdateLocalItemPopup from "./UpdateLocalItemPopup.vue";
import UpdateItemPopup from "./UpdateItemPopup.vue";


export default {
  name: 'AdminAllocation',
  props: {
    allocationData: Object
  },
  components: {
    UpdateLocalItemPopup,
    UpdateItemPopup,
    LocalAllocationOrders,
    AllocatedOrders,
    StepsHeader,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    VueGoodTable
  },
  data() {
    return {
      activeStep: 1,
      localStorageData: null,
      poData: {
        po_required: false,
        po_number: '',
        poDate: ''
      },
      addressData: {},
      allocation_qty: [],
      canSend: true,
      popupVisible: false,
      popupVisible2: false,
      updateItemIndex: 0,
      errorArray: [],
      updateAllocationData: {},
      currentAllocatedData: {}
    }
  },
  mounted() {
    this.getDataFromLocalStorage();
  },
  computed: {
    sortedAllocationItemsById(){
      return this.allocationData.lineItems.sort((a,b)=>{
        if (a.id < b.id) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        }
        return 0;
      })
    }
  },
  methods: {
    firstStepNextClick() {
      this.activeStep = 2;
    },
    secondStepNextClick(data) {
      this.poData = data;
      this.activeStep = 3;
    },
    thirdStepNextClick(data) {
      this.addressData = {
        address_id: data.address_id,
        address_name: data.address_name
      }
      this.activeStep = 4;
    },
    fourthStepNextClick(data) {
      this.specialInstructions = data.specialInstructions;
      this.activeStep = 5;
    },
    fifthStepNextClick(qty) {
      this.allocation_qty = qty;
      let data = {
        // CRAFT_CSRF_TOKEN: this.allocationData.csrf,
        address_id: this.addressData.address_id,
        address_name: this.addressData.address_name,
        allocation_qty: this.allocation_qty
      }

      if (this.poData.po_required) {
        data.po_number = this.poData.po_number;
        data.poDate = this.poData.poDate;
      }
      data.po_required = this.poData.po_required;
      data.specialInstructions = this.specialInstructions;

      this.localStorageData.push(data);
      this.setDataToLocalStorage();
      this.goToStep(1);
    },
    goToStep(index) {
      this.activeStep = index;
    },
    stepCancelClick() {
      this.activeStep = 1;
    },
    setDataToLocalStorage() {
      let data = localStorage.getItem('allocation');
      if (data) {
        data = JSON.parse(data);
      } else {
        data = {};
      }
      data['' + this.allocationData.id] = this.localStorageData;
      localStorage.setItem('allocation', JSON.stringify(data));
    },
    getDataFromLocalStorage() {
      let data = localStorage.getItem('allocation');
      let currentData = [];
      if (data) {
        data = JSON.parse(data);
        if (data.hasOwnProperty('' + this.allocationData.id)) {
          currentData = data['' + this.allocationData.id];
        }
      }
      this.localStorageData = currentData;
    },
    finishAllocated() {

      let hasError = this.checkRemainsItems();
      if (!hasError) {
        if (this.canSend) {
          this.canSend = false;
          sendOrder(this.allocationData.id, {
            CRAFT_CSRF_TOKEN: this.allocationData.csrf,
            data: this.localStorageData
          }).then(
              (res) => {
                if (res.status === 200) {
                  this.localStorageData = [];
                  this.setDataToLocalStorage();
                  this.canSend = true;
                  document.location.reload();
                }

              },
              (error) => {
                console.log(error);
              }
          )
        }
      }
    },
    deleteLocalItem(index) {
      this.errorArray = [];
      this.localStorageData.splice(index, 1);
      this.setDataToLocalStorage();
    },
    updateLocalItem(index) {
      this.errorArray = [];
      this.popupVisible = true;
      this.updateItemIndex = index;
      this.currentAllocatedData = this.localStorageData[index];

    },
    onSave(data) {

      // this.localStorageData[this.updateItemIndex] = data;
      this.$set(this.localStorageData,this.updateItemIndex,data);
      this.setDataToLocalStorage();
      this.popupVisible = false;
    },
    onCancel() {
      this.popupVisible = false;
    },
    checkRemainsItems() {
      this.errorArray = [];
      let allQty = {};

      for (let i = 0; i < this.localStorageData.length; i++) {
        let qty = this.localStorageData[i].allocation_qty;
        for (let prop in qty) {
          if (!allQty.hasOwnProperty('' + prop)) {
            allQty['' + prop] = 0;
          }
          allQty['' + prop] += Number(qty['' + prop]);
        }
      }
      for (let i = 0; i < this.allocationData.lineItems.length; i++) {
        let item = this.allocationData.lineItems[i];
        if (allQty['' + item.id] > item.remains) {
          this.errorArray.push(item.title + '- Allocated quantity is bigger than remaining for allocation ');
        }
      }
      return this.errorArray.length > 0;
    },
    deleteAllocatedItem(index) {
      deleteOrder(this.allocationData.allocations[index].id, {
        CRAFT_CSRF_TOKEN: this.allocationData.csrf
      }).then(
          (res) => {
            if (res.data.status === 200) {
              document.location.reload();
            }
          },
          (error) => {
            console.log(error);
          },
      )
    },
    updateAllocatedItem(index) {

      this.updateAllocationData = this.allocationData.allocations[index];
      // this.updatedItemsArray = this.allocationData.allocations[index].allocationItems;
      this.popupVisible2 = true;
      this.updateItemIndex = index;
      // this.errorArray = [];
      // this.popupVisible = true;
      // this.updateItemIndex = index;
    },
    onSave2(data) {
      // console.log(qty);
      updateOrder(this.allocationData.allocations[this.updateItemIndex].id, {
        CRAFT_CSRF_TOKEN: this.allocationData.csrf,
        data: data
      }).then(
          (res) => {
            if (res.data.status === 200) {
              // this.popupVisible2 = false;
              document.location.reload();
            }
          },
          (error) => {
            console.log(error);
          },
      )
    },
    onCancel2() {
      this.popupVisible2 = false;
    },
  }
}
</script>